import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-requirements',
  templateUrl: './faq-requirements.component.html',
  styleUrls: ['./faq-requirements.component.css']
})
export class FaqRequirementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
